import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @HostBinding('style.display') display = 'inital';
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter();

  _show = false;

  @Input() set show(_show) {
    this._show = _show;
    if (this._show) {
      this.display = 'initial';
    } else {
      this.display = 'none';
    }
  }

  sendClose() {
    this.close.emit();
  }
}
